module.exports = __webpack_public_path__ + "static/img/6.32c43e6d.png";